module.exports = require("./zen-observable.js").Observable;



//////////////////
// WEBPACK FOOTER
// ./~/zen-observable/index.js
// module id = 958
// module chunks = 231608221292675